import React from "react";
import Logo from "./Logo";
import LatestReportBadge from "./LatestReportBadge";

export default function Header({ hideLatestReportBadge = false }) {
  return (
    <header className="header">
      <div className="container headerInner">
        <a href="/" className="homeLink" aria-label="Home">
          <Logo />
        </a>

        {hideLatestReportBadge ? null : <LatestReportBadge placement="site_header" />}
      </div>
    </header>
  );
}
